import { formatEmptyValues } from './formatEmptyValues'
import { isNonNullRecord } from '@corratech/pylot-utils'

export const pushToDataLayer = (event: unknown): void => {
    if (typeof window !== 'object') {
        return
    }
    if (typeof window.dataLayer === 'undefined') {
        window.dataLayer = []
    }
    if (isNonNullRecord(event)) {
        event = formatEmptyValues(event)
    }
    window.dataLayer.push(event)
}
